import type { ReconcileSnippet, SnippetsPlugin } from '../snippetsPluginType';
import { registerConfluenceSnippets } from '../ui/quick-insert/registerConfluenceSnippets';

export const createReconcileSnippetCommand =
	(api: Parameters<SnippetsPlugin>[0]['api']): ReconcileSnippet =>
	({ snippet }) =>
	({ tr }) =>
		registerConfluenceSnippets({
			api,
			openTemplateGallery: undefined,
			snippets: [snippet],
			tr,
		});
